import { ICropping } from "../omnia"
import { INutritionPlan, INutritionPlanProductApp, INutritionService, NvzPlanCropping } from "../types"
import { ClosedPeriodControlService } from "./closedPeriod"
import { FieldLimitControlService } from "./field-limit"
import { checkNMax } from "./nmax"

export function createNvzControlService(svc: INutritionService, croppingProvider: () => NvzPlanCropping[]) {


    const fieldLimit = new FieldLimitControlService(svc)
    const closedPeriod = new ClosedPeriodControlService(svc, croppingProvider)

    return {

        checkFieldsLimit(model: INutritionPlan, croppings: NvzPlanCropping[]) {
            return fieldLimit.checkFieldsLimit(model, croppings)
        },

        checkNMax(model: INutritionPlan, crops: NvzPlanCropping[]) {
            return checkNMax(svc, model, crops)
        },

        getParentsSuppliedN(planId: number, cropping: ICropping, applicationsIds: number[], excludedCroppingIds: number[], minDate: Date, maxDate: Date) {
            return fieldLimit.getNFromPrevCrops(planId, cropping, applicationsIds, excludedCroppingIds, minDate, maxDate);
        },

        checkClosedPeriods(model: INutritionPlan, cropping: NvzPlanCropping[]) {
            return closedPeriod.checkClosedPeriods(model, cropping);
        },

        getNLeftFieldsLimit(model: INutritionPlan, cropping: NvzPlanCropping, application: INutritionPlanProductApp): number {
            return fieldLimit.getNLeftFieldsLimit(model, cropping, application);
        }

    }

}

